import { useEffect, useMemo, useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import ProductCard from "./ProductCard";

const hasAvailableStock = (product) => {
  const variants = Array.isArray(product?.variants) ? product.variants : [];

  if (variants.length) {
    return variants.some((variant) => variant?.is_active !== false && Number(variant?.stock || 0) > 0);
  }

  return Number(product?.stock || product?.available_stock || 0) > 0;
};

const ProductRecommendations = ({ title, products = [] }) => {
  const railRef = useRef(null);
  const [scrollState, setScrollState] = useState({
    canGoPrev: false,
    canGoNext: false
  });

  const visibleProducts = useMemo(
    () => (products || []).filter(hasAvailableStock).slice(0, 8),
    [products]
  );

  const updateScrollState = () => {
    const el = railRef.current;

    if (!el) return;

    const max = Math.max(el.scrollWidth - el.clientWidth, 0);
    const current = Math.abs(el.scrollLeft);

    setScrollState({
      canGoPrev: current > 8,
      canGoNext: current < max - 8
    });
  };

  const scrollRail = (direction) => {
    const el = railRef.current;

    if (!el) return;

    const amount = Math.max(Math.floor(el.clientWidth * 0.78), 260);
    const left = direction === "next" ? -amount : amount;

    el.scrollBy({
      left,
      behavior: "smooth"
    });

    window.setTimeout(updateScrollState, 360);
  };

  useEffect(() => {
    const el = railRef.current;

    if (!el) return undefined;

    updateScrollState();

    const onScroll = () => updateScrollState();
    const onResize = () => updateScrollState();

    el.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);

    const timeout = window.setTimeout(updateScrollState, 140);

    return () => {
      el.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      window.clearTimeout(timeout);
    };
  }, [visibleProducts.length]);

  if (!visibleProducts.length) return null;

  return (
    <section className="product-details-info-card product-recommend-section">
      <div className="product-description-card product-recommend-panel">
        <div className="product-section-head product-section-head-clean">
          <span>{title || "محصولات پیشنهادی برای شما"}</span>
        </div>

        <div className="home-products-scroll-shell product-recommend-scroll-shell">
          <button
            type="button"
            className="home-rail-floating-btn home-rail-floating-btn-right product-recommend-arrow"
            onClick={() => scrollRail("prev")}
            disabled={!scrollState.canGoPrev}
            aria-label="محصولات قبلی"
          >
            <FiChevronRight size={21} />
          </button>

          <div ref={railRef} className="home-products-grid home-products-rail product-recommend-rail">
            {visibleProducts.map((product, index) => (
              <ProductCard
                product={product}
                key={product._id || product.id}
                index={index}
                layout="rail"
                compact
              />
            ))}
          </div>

          <button
            type="button"
            className="home-rail-floating-btn home-rail-floating-btn-left product-recommend-arrow"
            onClick={() => scrollRail("next")}
            disabled={!scrollState.canGoNext}
            aria-label="محصولات بعدی"
          >
            <FiChevronLeft size={21} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductRecommendations;
